
import React from "react";

function Businesses() {
    return (<div>Businesses</div>);
}

export default Businesses;
